module.exports = __webpack_public_path__ + "static/media/T14-T25-07.762553af.svg";